const sendAnalytic = (category, name, variant = '') => {
    const gtag = window.gtag;

    if (typeof gtag !== 'function') {
        return;
    }

    gtag('event', 'purchase', {
        value: 1,
        currency: 'NTD',
        items: [{
            item_category: category,
            item_name: name,
            item_variant: variant
        }]
    });
};

export default sendAnalytic;
